import React from 'react';
import { emptyCellCharacter } from '../../constants/General';
import { RenderCellProps } from './index';

const Cell: React.FunctionComponent<RenderCellProps> = ({ value = emptyCellCharacter }) => {
  return <>{value}</>;
};

export default Cell;
